import { createContext, Dispatch, SetStateAction, useContext, useState } from "react";

import Editorials from "~/types/editorials";

type GiftCardMedia = {
  mediaUrl: string | undefined;
  selectedIndex: number;
  setSelectedIndex: Dispatch<SetStateAction<number>>;
};

const Context = createContext<GiftCardMedia | undefined>(undefined);

export default function GiftCardMediaProvider(props: {
  children: React.ReactNode;
  config?: Editorials.GiftCardsConfiguration;
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const virtualCard = props.config?.virtualCards.at(selectedIndex);

  const mediaUrl = virtualCard ? "https:" + virtualCard?.fields.cardImage.fields.file.url : undefined;

  return <Context.Provider value={{ mediaUrl, selectedIndex, setSelectedIndex }}>{props.children}</Context.Provider>;
}

export function useGiftCardMedia() {
  const context = useContext(Context);

  if (!context) {
    throw new Error(`useGiftCardMedia must be used within a GiftCardMediaProvider`);
  }

  return context;
}
